import { queryOptions } from "@tanstack/react-query";
import { authenticatedRequest } from "@/lib/graphql/client";
import { ADMIN_ACCOUNT_DELETION_SURVEYS } from "@/lib/graphql/queries/account-deletion-surveys";
import type {
  AccountDeletionReasonCount,
  AccountDeletionSurveyItem,
} from "@/types/account-deletion-survey";
import type { PaginationInput, PaginationMeta } from "@/types/common";

export const accountDeletionSurveyKeys = {
  all: ["accountDeletionSurveys"] as const,
  lists: () => [...accountDeletionSurveyKeys.all, "list"] as const,
  list: (pagination: PaginationInput) =>
    [...accountDeletionSurveyKeys.lists(), pagination] as const,
};

interface AdminAccountDeletionSurveysResponse {
  items: AccountDeletionSurveyItem[];
  meta: PaginationMeta;
  reasonCounts: AccountDeletionReasonCount[];
}

export function accountDeletionSurveysQueryOptions(pagination: PaginationInput) {
  return queryOptions({
    queryKey: accountDeletionSurveyKeys.list(pagination),
    queryFn: async () => {
      const data = await authenticatedRequest<{
        adminAccountDeletionSurveys: AdminAccountDeletionSurveysResponse;
      }>(ADMIN_ACCOUNT_DELETION_SURVEYS, {
        input: { page: pagination.page, limit: pagination.limit },
      });

      return data.adminAccountDeletionSurveys;
    },
    placeholderData: (previousData) => previousData,
    staleTime: 30000,
  });
}
